
import React, { useState } from "react";
import { auth, db } from "../FirebaseComp/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

import "./login.css";

// import { Eye, EyeOff } from "lucide-react";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();


  //PASSWORD VIEW
const [showPassword, setShowPassword] = useState(false);


  const login = async () => {
    try {
      // Sign in the user
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      // Fetch the user's role from Firestore
      const userDoc = await getDoc(doc(db, "users", userId));
      if (userDoc.exists()) {
        const { role } = userDoc.data();

        // Navigate to the appropriate dashboard based on role
           if (role === "admin") {
          navigate("/AdminPanel");
        } else if (role === "customer") {
          navigate("/CustomerDashboard");
        } else if (role === "sub-admin") {
          navigate("/sub-adminPanel");
        
        } 
        

        else {
          alert("Role not recognized. Contact admin.");
        }
      } else {
        alert("No user data found. Please contact admin.");
      }
    } catch (error) {
      console.error("Error logging in:", error.message);
      alert(error.message);
    }
  };



  const navigateToForgotPassword = () => {
   
    navigate('/ForgotPassword');
  };

  return (

<div className="login-wrapper">
  <div className="login-panel-box">
    <div className="login-form-panel">
      <h1 className="login-heading">Login Panel</h1>
      <input
        type="email"
        placeholder="Please Enter Your Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="login-input"
      />
      <input
        type={showPassword ? "text" : "password"}
        placeholder="Please Enter Your Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="login-input"
      />
      {/* <a href="#" className="forgot-password-link">Forgot Password?</a> */}
      <button onClick={login} className="login-btn">Login</button>
    </div>
    <div className="login-info-panel">
      <img src="ray-ban-logo.png" alt="ray-ban Logo" className="brand-logo" />
      <h4 className="brand-title">Optical Management System</h4>
      <p className="brand-description">
        Powered By <strong>GLAXMORE IT</strong> This System designed,
        Streamline your operations with ease, accuracy, and reliability.
      </p>
    </div>
  </div>
</div>
  );
};

export default Login;
